/**
 * Pure H OS · Phase D · P0 Interaction Depth · useLiveTick.
 *
 * Subscribes a component to the live cache mutation counter so it
 * re-renders when `upsertLocal` mutates a row. Used by drawers and
 * lists that need to reflect a PATCH result instantly.
 */
import { useEffect, useState } from "react";
import { mutationTick, subscribeMutations } from "../services/store";

export function useLiveTick(): number {
  const [tick, setTick] = useState<number>(mutationTick());
  useEffect(() => subscribeMutations(() => setTick(mutationTick())), []);
  return tick;
}
